import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5ebe906c&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=5ebe906c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebe906c",
  null
  
)

export default component.exports